/*
  Temporary patch: HELPER_UTIL.submitButtonState(btnInstance) assumes btnInstance
  is always a real button element and immediately does things like
  `btnInstance.disabled = ...` / `btnInstance.classList.add(...)`.

  The <product-card> component's quick-add form handler
  (handleProductFormSubmit) calls this with the native SubmitEvent's
  `e.submitter` as btnInstance. In some mobile browsers `e.submitter` comes
  back null for a real user click, which throws immediately and silently
  kills the quick-add/options-drawer interaction (the click does nothing,
  and shows up as a "dead click" in analytics) instead of opening the drawer.

  This wraps the original implementation so a missing button reference is a
  safe no-op instead of a crash. Every other caller is unaffected.
*/
(function () {
  if (typeof HELPER_UTIL === 'undefined' || typeof HELPER_UTIL.submitButtonState !== 'function') {
    return;
  }

  var originalSubmitButtonState = HELPER_UTIL.submitButtonState;

  HELPER_UTIL.submitButtonState = function (btnInstance) {
    if (!btnInstance) {
      var noop = function () {};
      return {
        completeState: noop,
        loadingState: noop,
        resetState: noop,
        disableState: noop
      };
    }
    return originalSubmitButtonState(btnInstance);
  };
})();
